import { inject } from '@angular/core';
import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthenticationCredentialsService } from '@modules/authentication/services/authentication-credentials.service';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';

export const isAuthenticatedGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  if (!inject(AuthenticationCredentialsService).user) {
    // The navigation target, not `location.href`: on an in-app navigation that's still the page being left.
    inject(AuthAppRedirectService).login(state.url);
    return false;
  }

  return true;
};
